import { render, staticRenderFns } from "./Inventory_Location.vue?vue&type=template&id=65703426"
import script from "./Inventory_Location.vue?vue&type=script&lang=js"
export * from "./Inventory_Location.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports